<template>
  <v-alert
    color="warning"
    text
    class="payment-warning-alert"
    border="left"
  >
    <div
      v-html-safe="$t('plans.onlyAdmin')"
      class="payment-warning-alert-text"
    />
  </v-alert>
</template>

<script>
export default {
  name: 'PaymentAccessControlAlert'
}
</script>

<style lang="scss">
.payment-warning-alert .v-alert__wrapper .v-alert__border {
  opacity: 1;
  border: 2px solid;
}

.v-alert.payment-warning-alert.v-sheet {
  padding: 0;
  margin-top: 24px;
  margin-bottom: 0;
}

.payment-warning-alert-text {
  color: var(--v-old-alert-warning-foreground-base);
  font-family: Roboto,serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;
  padding: 12px 14px;
}
</style>
